import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import LinkedIn from '@material-ui/icons/LinkedIn';
import CloseIcon from '@material-ui/icons/Close';
import LinkIcon from '@material-ui/icons/Link';
import Tooltip from '@material-ui/core/Tooltip';
import Snackbar from '@material-ui/core/Snackbar';
import FacebookIcon from '../statelessComponents/Icons/FacebookIcon';

import s from './ShareCertificateModal.scss';

const messages = defineMessages({
  title: {
    id: 'Cert.ShareCertificateModal.title',
    defaultMessage: 'Share this certificate',
    description:
      'Share this certificate title on share cert modal on cert page',
  },
  copyLinkBtnTooltip: {
    id: 'Cert.ShareCertificateModal.copyLinkBtnTooltip',
    defaultMessage: 'Copy the certificate link',
    description: 'Tooltip for the button to copy the certificate URL',
  },
  shareCertToFBBtnTooltip: {
    id: 'Cert.ShareCertificateModal.shareCertToFBBtnTooltip',
    defaultMessage: 'Share on Facebook',
    description:
      'Tooltip for the button to share the certificate URL on a Facebook post',
  },
  shareCertToLinkedInBtnTooltip: {
    id: 'Cert.ShareCertificateModal.shareCertToLinkedInBtnTooltip',
    defaultMessage: 'Share on LinkedIn',
    description:
      'Tooltip for the button to share the certificate URL on a LinkedIn post',
  },
  copyBtnMessage: {
    id: 'Cert.ShareCertificateModal.copyBtnMessage',
    defaultMessage: 'Link copied to clipboard',
    description:
      'Snackbar message displayed when the certificate URL is successfully copied',
  },
});

const ShareCertificateModal = ({
  onClose,
  certPage,
  certId,
  intl: { formatMessage },
}) => {
  const [copied, setCopied] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const shareUrl = `${window.location.origin}/${certPage}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setOpenSnackbar(true);
    });
  };

  const shareToLinkedInHandler = () => {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        shareUrl,
      )}`,
      '_blank',
    );
  };

  const shareToFacebookHandler = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?&u=${encodeURIComponent(
        shareUrl,
      )}`,
      '_blank',
    );
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <div className={s.paper} tabIndex="-1">
        <Typography className={s.text} variant="subtitle1">
          {formatMessage(messages.title)}
        </Typography>
        <div className={s.btnsContainer}>
          <Tooltip title={formatMessage(messages.copyLinkBtnTooltip)}>
            <Button
              data-test-id="lKhPYTukl8Sj0-OtpBZDz"
              variant="contained"
              color="primary"
              className={s.button}
              onClick={handleCopy}
            >
              <LinkIcon />
            </Button>
          </Tooltip>
          <Tooltip title={formatMessage(messages.shareCertToFBBtnTooltip)}>
            <Button
              data-test-id="Vc1iH-QYaUrnvMjcn04on"
              variant="contained"
              color="primary"
              className={s.button}
              onClick={shareToFacebookHandler}
            >
              <FacebookIcon color="white" />
            </Button>
          </Tooltip>
          <Tooltip
            title={formatMessage(messages.shareCertToLinkedInBtnTooltip)}
          >
            <Button
              data-test-id="hwJ-jvsWkMwMc-9OhhGCl"
              variant="contained"
              color="primary"
              className={s.button}
              onClick={shareToLinkedInHandler}
            >
              <LinkedIn />
            </Button>
          </Tooltip>
        </div>

        <div className={s.closeModalBtn}>
          <IconButton data-test-id="bnF3jer_CBxDET_jkcksC" onClick={onClose}>
            <CloseIcon className={s.closeIcon} />
          </IconButton>
        </div>
      </div>
      <Snackbar
        key={`successfullyCopiedLink-${certId}`}
        open={copied && openSnackbar}
        onClose={handleCloseSnackbar}
        autoHideDuration={8000}
        message={formatMessage(messages.copyBtnMessage)}
      />
    </>
  );
};

ShareCertificateModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  certPage: PropTypes.string.isRequired,
  certId: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(
  withStyles(s)(
    connect(state => ({ lang: state.intl.locale }))(ShareCertificateModal),
  ),
);
